import React, { useEffect, useState } from "react";
import "./LoanTab.scss";
import LoanDetailModal from "../LoanTable/LoanDetailModal";
import { getAllLoansFromBorrower } from "../../util/API/loandisk";
import { useSelector } from "react-redux";
import { TableHead, TableBody, Table, TableContainer, TableCell, TableRow, Box, Pagination, Button } from "@mui/material";
import { loanStatusIDs } from "../../util/utilfunctions/loandiskMappings";
import { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { sendLoanInterestEmail } from '../../util/API/loandisk';
import CustomAlert from "../UI/CustomAlert/CustomAlert";

function LoanTab() {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loanList, setLoanList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [selectedLoanData, setSelectedLoanData] = useState(null);
  const [tablePages, setTablePages] = useState(0);
  const [paginatedLoans, setPaginatedLoans] = useState([]);

  const currentUser = useSelector(
    (state) => state.usersList.selectedUser
  );

  const isSuperAdmin = sessionStorage.getItem("isSuperAdmin");
  const isLoanAdmin = sessionStorage.getItem("isLoanAdmin");

  console.log(isSuperAdmin)

  const [alert, setAlert] = useState(
    {
      showAlert: false,
      severity: "error",
      header: "",
      message: ""
    }
  )

  const handleClose = () => setOpen(false);
  const handleOpen = (loanid, rowData) => {
    console.log("rowData===============",rowData);
    console.log("currentUser===============",currentUser);
    setSelectedLoan(loanid);
    setSelectedLoanData(rowData);
    setOpen(true);
  };

  async function getLoanDiskLoans() {
    let response = await getAllLoansFromBorrower(currentUser?.User?.id, pageNumber);
    setIsLoading(false);
    if (response?.Status !== "1") {
      return;
    }
    let apiResponse = response?.payload?.body?.response;
    let loans = apiResponse?.Results?.record;
    if (loans && !Array.isArray(loans)) {
      loans = [loans];
    }
    // loans = loans.reverse();
    loans = loans.reverse();
    setLoanList(loans);
    console.log("LoanList-------------",loans);
    setTablePages(Math.ceil(apiResponse?.TotalResults / 5));
    paginateLoans(loans, 1);
  }

  const paginateLoans = (loans, pageNumber) => {
    const startIndex = (pageNumber - 1) * 5;
    const endIndex = startIndex + 5;
    const paginatedLoans = loans.slice(startIndex, endIndex); // Slice the data to show only 5 items per page
    setPaginatedLoans(paginatedLoans); // Set the loans for the current page
  }

  // const handlePageChange = async (page) => {
  //   setIsLoading(true);
  //   setPageNumber(page);
  //   let response = await getAllLoansFromBorrower(currentUser?.User?.id, page);
  //   if (response?.Status != 1) {
  //     return;
  //   }
  //   let loans = response?.payload?.body?.response?.Results?.record;
  //   if (!Array.isArray(loans)) {
  //     loans = [loans];
  //   }
  //   // loans = loans.reverse();
  //   setLoanList(loans || []);
  //   setIsLoading(false);
  // }

  const handlePageChange = (page) => {
    setPageNumber(page); // Set the new page number
    paginateLoans(loanList, page); // Paginate the data for the selected page
  };

  useEffect(() => {
    getLoanDiskLoans();
  }, []);

  useEffect(() => {
    paginateLoans(loanList, pageNumber); // Re-paginate when the page number changes
  }, [pageNumber, loanList]);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: 'rgba(0,0,0, .1)',
      color: theme.palette.common.black,
      fontWeight: 'bold'
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 25,
      fontWeight: '600'
    },
  }));

  const handleLoanInterest = async() => {
    try {
      console.log(currentUser);
      const response = await sendLoanInterestEmail(
        currentUser?.User?.firstName, currentUser?.Useremailaccount?.emailAccount, `${currentUser?.User?.firstName} ${currentUser?.User?.lastName} is interested in a Loan`, `${currentUser?.User?.firstName} ${currentUser?.User?.lastName} is interested in a Loan. They can be reached at ${currentUser?.Useremailaccount?.emailAccount} or by phone at ${currentUser?.User?.contactPhoneNo}.`
      );
        
      if (response?.callStatus === "1") {
        setAlert({
          showAlert: true,
          severity: "success",
          header: "Success",
          message: "Loan Interest Shared"
        })
      } else {
        setAlert({
          showAlert: true,
          severity: "error",
          header: "Error",
          message: response?.payload?.msg
        })
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="loan-tab-container">
      <LoanDetailModal open={open} handleClose={handleClose} loanid={selectedLoan} loanData={selectedLoanData} />
      <header>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0"> Loan Assignment</h5>
          <Button
            variant="contained"
            color="primary"
            onClick={handleLoanInterest}
          >
            Interested in Loan
          </Button>
        </div>
        <div className="loan-details-table">
          {isLoading && <div className="text-center mt-5">
            <span className="loader" />
          </div>}
          {!isLoading && (isSuperAdmin === "true" || isLoanAdmin === "true") && 
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Reference Id</StyledTableCell>
                    <StyledTableCell>Loan Status</StyledTableCell>
                    <StyledTableCell>Principal Amount</StyledTableCell> 
                    <StyledTableCell>Action</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* {loanList && loanList.map((row, index) => ( */}
                  {paginatedLoans && paginatedLoans?.map((row, index) => (
                    <TableRow key={row?.loan_id}>
                      <TableCell align="left" className="">
                        <div>
                          {row?.loan_application_id}
                        </div>
                      </TableCell>
                      <TableCell align="left" className="">
                        <div>
                          {loanStatusIDs[row?.loan_status_id]}
                        </div>
                      </TableCell>
                      <TableCell align="left" className="">
                        <div>
                          {row?.loan_principal_amount}
                        </div>
                      </TableCell>
                      <TableCell align="left" className="">
                        <Button 
                          onClick={() => handleOpen(row?.loan_id, row)}
                           variant="contained"
                        >
                          Manage
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          }
          {(isSuperAdmin === "true" || isLoanAdmin === "true") && <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 2 }}>
            <Pagination
              count={tablePages}
              color="primary"
              onChange={(event, page) => handlePageChange(page)}
              showFirstButton 
              showLastButton
            />
          </Box>}

        </div>
      </header>

      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        onClick={() => {setAlert({ ...alert, showAlert: false });}}
        autoclose={alert.severity === "error" ? false : true}
      />
    </div>
  );
}

export default LoanTab;
